import React, { useState, useEffect } from 'react';
import './EmailConfig.css';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Plus, Trash2 } from 'lucide-react';
import { toast } from 'react-toastify';
import { regexEmail } from '../../utils';
import { useTranslation } from 'react-i18next';
import settingsService from '../../services/settings.service';

export default function EmailConfig() {
  const { t } = useTranslation();

  const [emails, setEmails] = useState([]);
  const [emailToAdd, setEmailToAdd] = useState('');

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const data = await settingsService.getSettings();
        if (data) {
          setEmails(data[0].companyEmail || []);
        }
      } catch (ex) {
        console.error(ex);
        toast.error(t('admin.errorLoadingEmails'));
      }
    };
    fetchInfo();
  }, []);

  const addEmailHandler = async e => {
    e.preventDefault();
    if (regexEmail.test(emailToAdd) && emails.indexOf(emailToAdd) === -1) {
      let newEmails = [emailToAdd].concat(emails);
      try {
        await settingsService.updateEmailSettings(newEmails);
        setEmails(newEmails);
        setEmailToAdd('');
        toast.success(t('admin.emailsUpdated'));
      } catch (ex) {
        console.error(ex);
        toast.error(t('admin.emailSaveError'));
      }
    } else {
      toast.error(t('admin.invalidEmail'));
    }
  };

  const deleteEmailHandler = async email => {
    let deleteIndex = emails.indexOf(email);
    if (deleteIndex !== -1) {
      let newEmails = new Array(...emails);
      newEmails.splice(deleteIndex, 1);
      try {
        await settingsService.updateEmailSettings(newEmails);
        setEmails(newEmails);
        toast.success(t('admin.emailsUpdated'));
      } catch (ex) {
        console.error(ex);
        toast.error(t('admin.emailSaveError'));
      }
    }
  };

  return (
    <div className='email-config'>
      <p className='text-sm text-muted-foreground mb-3'>{t('admin.addAdminEmails')}</p>
      <form className='flex items-center gap-2 max-w-lg' onSubmit={addEmailHandler}>
        <div className='flex-1'>
          <Input
            onChange={e => setEmailToAdd(e.target.value)}
            value={emailToAdd}
            required
            placeholder={t('auth.email')}
          />
        </div>
        <Button size='icon-sm' type='submit'>
          <Plus className='h-4 w-4' />
        </Button>
      </form>
      <div className='mt-2 max-w-lg'>
        <ul className='mb-1 space-y-1'>
          {emails.length > 0 &&
            emails.map((email, index) => (
              <li
                key={index}
                className='flex items-center justify-between rounded-md border border-border bg-background px-4 py-2.5 text-sm text-foreground'
              >
                <span>{email}</span>
                <Button
                  variant='ghost'
                  size='icon-sm'
                  type='button'
                  onClick={() => deleteEmailHandler(email)}
                  title={t('common.delete')}
                >
                  <Trash2 className='h-4 w-4 text-destructive' />
                </Button>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}
